import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

/** Type description */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  /** field description */
  id: Scalars['Int']['output'];
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  BillingNote = 'billing_note',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  DepositInvoice = 'deposit_invoice',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Maintenance = 'maintenance',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Tire = 'tire',
  User = 'user',
  Vehicle = 'vehicle'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  Active = 'active',
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  ChangePassword = 'change_password',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  CreateImporter = 'create_importer',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  EditImporter = 'edit_importer',
  EditPermission = 'edit_permission',
  Image = 'image',
  InActive = 'in_active',
  SaveDatePayment = 'save_date_payment',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent'
}

export type AddressInputObject = {
  address_contact_fax?: InputMaybe<Scalars['String']['input']>;
  address_contact_name?: InputMaybe<Scalars['String']['input']>;
  address_contact_phone?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_same_as_default_address?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sub_district?: InputMaybe<Scalars['String']['input']>;
};

export type AddressObject = {
  __typename?: 'AddressObject';
  address_contact_fax?: Maybe<Scalars['String']['output']>;
  address_contact_name?: Maybe<Scalars['String']['output']>;
  address_contact_phone?: Maybe<Scalars['String']['output']>;
  address_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_default_address?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  sub_district?: Maybe<Scalars['String']['output']>;
};

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type AttachmentInputObject = {
  attachment_name?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<CreatorInputObject>;
  uploaded_date?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentObject = {
  __typename?: 'AttachmentObject';
  attachment_name?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<CreatorObject>;
  uploaded_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type CompanyUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelInputObject = {
  contact_channel_info?: InputMaybe<Scalars['String']['input']>;
  contact_channel_type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelObject = {
  __typename?: 'ContactChannelObject';
  contact_channel_info?: Maybe<Scalars['String']['output']>;
  contact_channel_type?: Maybe<Scalars['String']['output']>;
};

export type CreateGoodAdjustInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  created_by: CreatorInputObject;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status: GoodAdjustStatus;
  posted_date: Scalars['DateTime']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id: Scalars['Int']['input'];
  trace_entry_list: Array<TraceEntryCreateInput>;
  unique_id: Scalars['String']['input'];
};

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockBySnReportView = {
  __typename?: 'CurrentStockBySNReportView';
  barcode?: Maybe<Scalars['String']['output']>;
  bin_location_id?: Maybe<Scalars['Int']['output']>;
  bin_name?: Maybe<Scalars['String']['output']>;
  cate_1?: Maybe<Scalars['String']['output']>;
  cate_1_id?: Maybe<Scalars['Int']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockBySnReportViewAggrid = {
  __typename?: 'CurrentStockBySNReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockBySnReportView>>;
};

export type CurrentStockByWarehouseReportView = {
  __typename?: 'CurrentStockByWarehouseReportView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  max_stock_qty?: Maybe<Scalars['Float']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Float']['output']>;
  min_stock_qty?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reorder_point?: Maybe<Scalars['Float']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  warehouse_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CurrentStockByWarehouseReportViewAggrid = {
  __typename?: 'CurrentStockByWarehouseReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<CurrentStockByWarehouseReportView>>;
};

export type CustomGoodAdjust = {
  __typename?: 'CustomGoodAdjust';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<GoodAdjust>>>;
};

export type GeneralExportInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GoodAdjust = {
  __typename?: 'GoodAdjust';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse?: Maybe<Warehouse>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  trace_entry_list?: Maybe<Array<Maybe<TraceEntry>>>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export enum GoodAdjustStatus {
  Draft = 'draft',
  Finished = 'finished'
}

export type GoodAdjustView = {
  __typename?: 'GoodAdjustView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type GoodAdjustViewAggrid = {
  __typename?: 'GoodAdjustViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodAdjustView>;
};

export type GoodTransfer = {
  __typename?: 'GoodTransfer';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_warehouse?: Maybe<Scalars['Json']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  flag_status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['Int']['output'];
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse?: Maybe<Scalars['Json']['output']>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  trace_entry_list?: Maybe<Array<Maybe<TraceEntry>>>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type GoodTransferCreateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<CreatorInputObject>;
  destination_warehouse?: InputMaybe<Scalars['Json']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse?: InputMaybe<Scalars['Json']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodTransferUpdateInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  destination_warehouse?: InputMaybe<Scalars['Json']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse?: InputMaybe<Scalars['Json']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<InputMaybe<TraceEntryUpdateInput>>>;
};

export type GoodTransferView = {
  __typename?: 'GoodTransferView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type GoodTransferViewAggrid = {
  __typename?: 'GoodTransferViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodTransferView>;
};

export type GoodsAdjustUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsIssue = {
  __typename?: 'GoodsIssue';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse?: Maybe<Warehouse>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  trace_entry_list?: Maybe<Array<TraceEntry>>;
  type?: Maybe<GoodsIssueType>;
  unique_id: Scalars['String']['output'];
};

export type GoodsIssueCreateInput = {
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<GoodsIssueType>;
  unique_id: Scalars['String']['input'];
};

export enum GoodsIssueType {
  Maintenance = 'maintenance',
  Other = 'other',
  Return = 'return'
}

export type GoodsIssueUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsIssueUpdateInput = {
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryUpdateInput>>;
  type?: InputMaybe<GoodsIssueType>;
};

export type GoodsIssueView = {
  __typename?: 'GoodsIssueView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GoodsIssueType>;
  unique_id: Scalars['String']['output'];
};

export type GoodsIssueViewAggrid = {
  __typename?: 'GoodsIssueViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsIssueView>;
};

export type GoodsReceive = {
  __typename?: 'GoodsReceive';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse?: Maybe<Warehouse>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  trace_entry_list?: Maybe<Array<TraceEntry>>;
  type?: Maybe<GoodsReceiveType>;
  unique_id: Scalars['String']['output'];
};

export type GoodsReceiveCreateInput = {
  created_by?: InputMaybe<CreatorInputObject>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
};

export enum GoodsReceiveType {
  Other = 'other',
  Purchase = 'purchase',
  Return = 'return'
}

export type GoodsReceiveUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type GoodsReceiveUpdateInput = {
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status: Scalars['String']['input'];
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  reference_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<TraceEntryUpdateInput>>;
  type?: InputMaybe<GoodsReceiveType>;
};

export type GoodsReceiveView = {
  __typename?: 'GoodsReceiveView';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GoodsReceiveType>;
  unique_id: Scalars['String']['output'];
};

export type GoodsReceiveViewAggrid = {
  __typename?: 'GoodsReceiveViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<GoodsReceiveView>;
};

export type GoodsTransferUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ImageUrlInputObjectInput = {
  img_url?: InputMaybe<Scalars['String']['input']>;
  is_main_img?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageUrlObject = {
  __typename?: 'ImageUrlObject';
  img_url?: Maybe<Scalars['String']['output']>;
  is_main_img?: Maybe<Scalars['Boolean']['output']>;
};

export enum InventoryControlDocumentType {
  GoodAdjust = 'good_adjust',
  GoodIssue = 'good_issue',
  GoodReceive = 'good_receive',
  GoodTransfer = 'good_transfer'
}

export type InventoryControlUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryDocumentCancelOutput = {
  __typename?: 'InventoryDocumentCancelOutput';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
};

export enum InventoryModelType {
  GoodAdjust = 'good_adjust',
  GoodIssue = 'good_issue',
  GoodReceive = 'good_receive',
  GoodTransfer = 'good_transfer',
  Item = 'item',
  Service = 'service'
}

export enum InventoryReportType {
  CurrentStockBySn = 'current_stock_by_sn',
  CurrentStockByWarehouse = 'current_stock_by_warehouse',
  NoTraceEntry = 'no_trace_entry',
  TraceEntry = 'trace_entry'
}

export type InventorySetting = {
  __typename?: 'InventorySetting';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: InventorySettingType;
};

export enum InventorySettingType {
  Cate_1 = 'cate_1',
  Cate_2 = 'cate_2',
  Cate_3 = 'cate_3',
  Unit = 'unit'
}

export type Item = {
  __typename?: 'Item';
  available_qty?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  cate_1?: Maybe<InventorySetting>;
  cate_1_id?: Maybe<Scalars['Int']['output']>;
  cate_2?: Maybe<InventorySetting>;
  cate_2_id?: Maybe<Scalars['Int']['output']>;
  cate_3?: Maybe<InventorySetting>;
  cate_3_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  height_uom?: Maybe<InventorySetting>;
  height_uom_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  img_url_list?: Maybe<Array<ImageUrlObject>>;
  is_active: Scalars['Int']['output'];
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  length_uom?: Maybe<InventorySetting>;
  length_uom_id?: Maybe<Scalars['Int']['output']>;
  max_stock_qty?: Maybe<Scalars['Float']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Float']['output']>;
  min_stock_qty?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom?: Maybe<InventorySetting>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom?: Maybe<InventorySetting>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  stock_uom?: Maybe<InventorySetting>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  thick?: Maybe<Scalars['Float']['output']>;
  thickness_uom?: Maybe<InventorySetting>;
  thickness_uom_id?: Maybe<Scalars['Int']['output']>;
  tracability?: Maybe<Traceability>;
  type?: Maybe<ItemType>;
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<UomConversion>>;
  width?: Maybe<Scalars['Float']['output']>;
  width_uom?: Maybe<InventorySetting>;
  width_uom_id?: Maybe<Scalars['Int']['output']>;
};

export type ItemAggrid = {
  __typename?: 'ItemAggrid';
  count: Scalars['Int']['output'];
  results: Array<Item>;
};

export type ItemCountOutput = {
  __typename?: 'ItemCountOutput';
  normal: Scalars['Float']['output'];
  service: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ItemCreateInput = {
  barcode: Scalars['String']['input'];
  cate_1_id?: InputMaybe<Scalars['Int']['input']>;
  cate_2_id?: InputMaybe<Scalars['Int']['input']>;
  cate_3_id?: InputMaybe<Scalars['Int']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  height_uom_id?: InputMaybe<Scalars['Int']['input']>;
  img_url_list?: InputMaybe<Array<ImageUrlInputObjectInput>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_uom_id?: InputMaybe<Scalars['Int']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Float']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_id?: InputMaybe<Scalars['Int']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_id?: InputMaybe<Scalars['Int']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  thick?: InputMaybe<Scalars['Float']['input']>;
  thickness_uom_id?: InputMaybe<Scalars['Int']['input']>;
  tracability?: InputMaybe<Traceability>;
  type: ItemType;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionInput>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemIdByBarcodeOutput = {
  __typename?: 'ItemIdByBarcodeOutput';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ItemType>;
};

export type ItemImportInput = {
  data: Array<Scalars['Any']['input']>;
  import_mode: ItemImportMode;
  import_type: ItemImportType;
  user_unique_id: Scalars['String']['input'];
};

export enum ItemImportMode {
  Create = 'create',
  Update = 'update'
}

export type ItemImportResult = {
  __typename?: 'ItemImportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum ItemImportType {
  Normal = 'normal',
  Service = 'service'
}

export type ItemInputValidateInput = {
  barcode_list?: InputMaybe<Array<Scalars['String']['input']>>;
  height_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  import_mode: ItemImportMode;
  item_cate_1_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  item_cate_2_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  item_cate_3_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  item_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  length_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  sales_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  stock_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  thickness_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  width_uom_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ItemNormalImportCreateInput = {
  barcode: Scalars['String']['input'];
  cate_1?: InputMaybe<Scalars['String']['input']>;
  cate_2?: InputMaybe<Scalars['String']['input']>;
  cate_3?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  height_uom?: InputMaybe<Scalars['String']['input']>;
  img_url_list?: InputMaybe<Array<ImageUrlInputObjectInput>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_uom?: InputMaybe<Scalars['String']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Float']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom?: InputMaybe<Scalars['String']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  thick?: InputMaybe<Scalars['Float']['input']>;
  thickness_uom?: InputMaybe<Scalars['String']['input']>;
  tracability?: InputMaybe<Traceability>;
  type: ItemType;
  unique_id: Scalars['String']['input'];
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionInput>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_uom?: InputMaybe<Scalars['String']['input']>;
};

export type ItemNormalImportInput = {
  data: Array<ItemNormalImportCreateInput>;
  import_mode: ItemImportMode;
  user_unique_id: Scalars['String']['input'];
};

export type ItemServiceImportCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  cate_1?: InputMaybe<Scalars['String']['input']>;
  cate_2?: InputMaybe<Scalars['String']['input']>;
  cate_3?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom?: InputMaybe<Scalars['String']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom?: InputMaybe<Scalars['String']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: ItemType;
  unique_id: Scalars['String']['input'];
};

export type ItemServiceImportInput = {
  data: Array<ItemServiceImportCreateInput>;
  import_mode: ItemImportMode;
  user_unique_id: Scalars['String']['input'];
};

export type ItemSkuQty = {
  __typename?: 'ItemSkuQty';
  available_qty: Scalars['Float']['output'];
  barcode: Scalars['String']['output'];
  bin_location: BinLocation;
  bin_location_id: Scalars['Int']['output'];
  bin_name: Scalars['String']['output'];
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  item_unique_id: Scalars['String']['output'];
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty: Scalars['Float']['output'];
  sale_committed_qty: Scalars['Float']['output'];
  serial_no: Scalars['String']['output'];
  stock_qty: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouse_id: Scalars['Int']['output'];
  warehouse_name: Scalars['String']['output'];
};

export type ItemSkuQtyByBarcodesView = {
  __typename?: 'ItemSkuQtyByBarcodesView';
  available_qty: Scalars['Float']['output'];
  barcode: Scalars['String']['output'];
  bin_location_id: Scalars['Int']['output'];
  bin_name: Scalars['String']['output'];
  item_id: Scalars['Int']['output'];
  item_unique_id: Scalars['String']['output'];
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty: Scalars['Float']['output'];
  sale_committed_qty: Scalars['Float']['output'];
  serial_no?: Maybe<Scalars['String']['output']>;
  stock_qty: Scalars['Float']['output'];
  warehouse_id: Scalars['Int']['output'];
  warehouse_name: Scalars['String']['output'];
  warehouse_unique_id: Scalars['String']['output'];
};

export type ItemSkuQtyByBarcodesViewAggridOutput = {
  __typename?: 'ItemSkuQtyByBarcodesViewAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByBarcodesView>;
};

export type ItemSkuQtyByBinLocationsView = {
  __typename?: 'ItemSkuQtyByBinLocationsView';
  available_qty: Scalars['Float']['output'];
  bin_location_id: Scalars['Int']['output'];
  bin_name: Scalars['String']['output'];
  item_id: Scalars['Int']['output'];
  item_unique_id: Scalars['String']['output'];
  purchase_ordered_qty: Scalars['Float']['output'];
  sale_committed_qty: Scalars['Float']['output'];
  stock_qty: Scalars['Float']['output'];
  warehouse_id: Scalars['Int']['output'];
  warehouse_name: Scalars['String']['output'];
  warehouse_unique_id: Scalars['String']['output'];
};

export type ItemSkuQtyByBinLocationsViewAggridOutput = {
  __typename?: 'ItemSkuQtyByBinLocationsViewAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByBinLocationsView>;
};

export type ItemSkuQtyByWarehousesView = {
  __typename?: 'ItemSkuQtyByWarehousesView';
  available_qty: Scalars['Float']['output'];
  item_id: Scalars['Int']['output'];
  item_unique_id: Scalars['String']['output'];
  purchase_ordered_qty: Scalars['Float']['output'];
  sale_committed_qty: Scalars['Float']['output'];
  stock_qty: Scalars['Float']['output'];
  warehouse_id: Scalars['Int']['output'];
  warehouse_name: Scalars['String']['output'];
  warehouse_unique_id: Scalars['String']['output'];
};

export type ItemSkuQtyByWarehousesViewAggridOutput = {
  __typename?: 'ItemSkuQtyByWarehousesViewAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<ItemSkuQtyByWarehousesView>;
};

export type ItemSkuQtyFindManyInput = {
  cursor?: InputMaybe<ItemSkuQtyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ItemSkuQtyScalarFieldEnum>>>;
  include?: InputMaybe<ItemSkuQtyIncludeInput>;
  orderBy?: InputMaybe<Scalars['Any']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemSkuQtyWhereInput>;
};

export enum ItemSkuQtyGroupingType {
  Barcode = 'barcode',
  BinLocation = 'bin_location',
  Warehouse = 'warehouse'
}

export type ItemSkuQtyIncludeInput = {
  item_sku_detail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemSkuQtyItemSumOutput = {
  __typename?: 'ItemSkuQtyItemSumOutput';
  available_qty: Scalars['Float']['output'];
  item_unique_id: Scalars['String']['output'];
  purchase_ordered_qty: Scalars['Float']['output'];
  sale_committed_qty: Scalars['Float']['output'];
  stock_qty: Scalars['Float']['output'];
};

export enum ItemSkuQtyScalarFieldEnum {
  BinLocationId = 'bin_location_id',
  Id = 'id',
  ItemUniqueId = 'item_unique_id',
  WarehouseId = 'warehouse_id'
}

export type ItemSkuQtyUniqueGroupedInput = {
  barcode: Scalars['String']['input'];
  bin_location_id: Scalars['Int']['input'];
  item_unique_id: Scalars['String']['input'];
  serial_no?: InputMaybe<Scalars['String']['input']>;
  warehouse_id: Scalars['Int']['input'];
};

export type ItemSkuQtyWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ItemSkuQtyWhereInput>>>;
  barcode?: InputMaybe<Scalars['Any']['input']>;
  bin_name?: InputMaybe<Scalars['Any']['input']>;
  id?: InputMaybe<Scalars['Any']['input']>;
  item_unique_id?: InputMaybe<Scalars['Any']['input']>;
  serial_no?: InputMaybe<Scalars['Any']['input']>;
  sku_name?: InputMaybe<Scalars['Any']['input']>;
};

export type ItemSkuQtyWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  item_unique_id_bin_location_id_warehouse_id_barcode_serial_no?: InputMaybe<ItemSkuQtyUniqueGroupedInput>;
};

export enum ItemType {
  Normal = 'normal',
  Service = 'service'
}

export type ItemUniqueInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ItemUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  cate_1_id?: InputMaybe<Scalars['Int']['input']>;
  cate_2_id?: InputMaybe<Scalars['Int']['input']>;
  cate_3_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  height_uom_id?: InputMaybe<Scalars['Int']['input']>;
  img_url_list?: InputMaybe<Array<ImageUrlInputObjectInput>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_saleable?: InputMaybe<Scalars['Boolean']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  length_uom_id?: InputMaybe<Scalars['Int']['input']>;
  max_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_request_qty?: InputMaybe<Scalars['Float']['input']>;
  min_stock_qty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  purchase_uom_id?: InputMaybe<Scalars['Int']['input']>;
  purchase_vat_type?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  sale_vat_type?: InputMaybe<Scalars['String']['input']>;
  sales_uom_id?: InputMaybe<Scalars['Int']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  special_price?: InputMaybe<Scalars['Float']['input']>;
  stock_uom_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  thick?: InputMaybe<Scalars['Float']['input']>;
  thickness_uom_id?: InputMaybe<Scalars['Int']['input']>;
  tracability?: InputMaybe<Traceability>;
  type?: InputMaybe<ItemType>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<UomConversionInput>>>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemView = {
  __typename?: 'ItemView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  cate_1?: Maybe<Scalars['String']['output']>;
  cate_2?: Maybe<Scalars['String']['output']>;
  cate_3?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hidden_barcode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url_list?: Maybe<Array<Scalars['Json']['output']>>;
  is_active?: Maybe<Scalars['Int']['output']>;
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_uom_name?: Maybe<Scalars['String']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  sale_committed_qty?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  sales_uom_name?: Maybe<Scalars['String']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  stock_uom_name?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  tracability?: Maybe<Traceability>;
  type?: Maybe<ItemType>;
  unique_id: Scalars['String']['output'];
  uom_conversion_list?: Maybe<Array<Scalars['Json']['output']>>;
};

export type ItemViewAggrid = {
  __typename?: 'ItemViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ItemView>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ClearReportRequestHistory: Scalars['Boolean']['output'];
  GoodAdjustCreate: GoodAdjust;
  GoodAdjustUpdate: GoodAdjust;
  GoodTransferCreate?: Maybe<GoodTransfer>;
  GoodTransferUpdate?: Maybe<GoodTransfer>;
  GoodsIssueCreate: GoodsIssue;
  GoodsIssueUpdate: GoodsIssue;
  GoodsReceiveCreate: GoodsReceive;
  GoodsReceiveUpdate: GoodsReceive;
  ImportNormalItems: ItemImportResult;
  ImportServiceItems: ItemImportResult;
  InventoryDocumentCancel?: Maybe<InventoryDocumentCancelOutput>;
  ItemCreate?: Maybe<Item>;
  ItemDelete?: Maybe<Item>;
  ItemUpdate?: Maybe<Item>;
  recalculateAllItemSkuQtys: Scalars['Boolean']['output'];
};


export type MutationGoodAdjustCreateArgs = {
  createGoodAdjustInput: CreateGoodAdjustInput;
};


export type MutationGoodAdjustUpdateArgs = {
  uniqueInput: GoodsAdjustUniqueInput;
  updateGoodAdjustInput: UpdateGoodAdjustInput;
};


export type MutationGoodTransferCreateArgs = {
  data?: InputMaybe<GoodTransferCreateInput>;
};


export type MutationGoodTransferUpdateArgs = {
  data?: InputMaybe<GoodTransferUpdateInput>;
  uniqueInput: GoodsTransferUniqueInput;
};


export type MutationGoodsIssueCreateArgs = {
  createInput: GoodsIssueCreateInput;
};


export type MutationGoodsIssueUpdateArgs = {
  uniqueInput: GoodsIssueUniqueInput;
  updateInput: GoodsIssueUpdateInput;
};


export type MutationGoodsReceiveCreateArgs = {
  createInput: GoodsReceiveCreateInput;
};


export type MutationGoodsReceiveUpdateArgs = {
  uniqueInput: GoodsReceiveUniqueInput;
  updateInput: GoodsReceiveUpdateInput;
};


export type MutationImportNormalItemsArgs = {
  importInput: ItemNormalImportInput;
};


export type MutationImportServiceItemsArgs = {
  importInput: ItemServiceImportInput;
};


export type MutationInventoryDocumentCancelArgs = {
  documentType?: InputMaybe<InventoryControlDocumentType>;
  uniqueInput: InventoryControlUniqueInput;
};


export type MutationItemCreateArgs = {
  createInput: ItemCreateInput;
};


export type MutationItemDeleteArgs = {
  uniqueInput: ItemUniqueInput;
};


export type MutationItemUpdateArgs = {
  uniqueInput: ItemUniqueInput;
  updateInput: ItemUpdateInput;
};

export type NoTraceEntryReportView = {
  __typename?: 'NoTraceEntryReportView';
  available_qty?: Maybe<Scalars['Float']['output']>;
  cate_1?: Maybe<Scalars['String']['output']>;
  cate_1_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<ItemType>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type NoTraceEntryReportViewAggrid = {
  __typename?: 'NoTraceEntryReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<NoTraceEntryReportView>>;
};

export enum PriceVatType {
  ExcludedVat = 'excluded_vat',
  IncludedVat = 'included_vat'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItemInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_desc?: InputMaybe<Scalars['String']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type?: InputMaybe<ReferenceDocumentType>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  rs_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['Json']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  wait_receive_qty?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseItemList = {
  __typename?: 'PurchaseItemList';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_desc?: Maybe<Scalars['String']['output']>;
  item_id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  reference_document_type?: Maybe<ReferenceDocumentType>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  rs_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  traceability?: Maybe<Traceability>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['Json']['output']>;
  uom_conversion_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  wait_receive_qty?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  CurrentStockBySNReportView?: Maybe<CurrentStockBySnReportViewAggrid>;
  CurrentStockByWarehouseReportView?: Maybe<CurrentStockByWarehouseReportViewAggrid>;
  GenerateReportNoQueue?: Maybe<Scalars['String']['output']>;
  GoodAdjustFindAll?: Maybe<Array<Maybe<GoodAdjust>>>;
  GoodAdjustFindManyAggrid: CustomGoodAdjust;
  GoodAdjustFindUnique?: Maybe<GoodAdjust>;
  GoodAdjustsViewAggrid: GoodAdjustViewAggrid;
  GoodTransferFindAll?: Maybe<Array<Maybe<GoodTransfer>>>;
  GoodTransferFindUnique?: Maybe<GoodTransfer>;
  GoodTransfersViewAggrid: GoodTransferViewAggrid;
  GoodsIssueFindUnique?: Maybe<GoodsIssue>;
  GoodsIssuesFindAll?: Maybe<Array<GoodsIssue>>;
  GoodsIssuesViewAggrid: GoodsIssueViewAggrid;
  GoodsReceiveFindUnique?: Maybe<GoodsReceive>;
  GoodsReceivesFindAll?: Maybe<Array<GoodsReceive>>;
  GoodsReceivesViewAggrid: GoodsReceiveViewAggrid;
  ItemFindUnique?: Maybe<Item>;
  ItemIdByBarcode?: Maybe<ItemIdByBarcodeOutput>;
  ItemSkuQtyByBarcodesViewAggrid: ItemSkuQtyByBarcodesViewAggridOutput;
  ItemSkuQtyByBinLocationsViewAggrid: ItemSkuQtyByBinLocationsViewAggridOutput;
  ItemSkuQtyByWarehousesViewAggrid: ItemSkuQtyByWarehousesViewAggridOutput;
  ItemSkuQtyItemSum: ItemSkuQtyItemSumOutput;
  ItemSkuQtys?: Maybe<Array<Maybe<ItemSkuQty>>>;
  ItemsCount: ItemCountOutput;
  ItemsFindManyAggrid: ItemAggrid;
  ItemsViewAggrid: ItemViewAggrid;
  NoTraceEntryReportView?: Maybe<NoTraceEntryReportViewAggrid>;
  TraceEntriesAggrid: TraceEntryAggridOutput;
  TraceEntriesViewAggrid: TraceEntryViewAggridOutput;
  TraceEntryReportView?: Maybe<TraceEntryReportViewAggrid>;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
  ValidateItemImport: ValidateItemImportResult;
};


export type QueryCurrentStockBySnReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryCurrentStockByWarehouseReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGenerateReportNoQueueArgs = {
  input: ReportGenerateInput;
};


export type QueryGoodAdjustFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGoodAdjustFindUniqueArgs = {
  uniqueInput: GoodsAdjustUniqueInput;
};


export type QueryGoodAdjustsViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryGoodTransferFindUniqueArgs = {
  uniqueInput?: InputMaybe<GoodsTransferUniqueInput>;
};


export type QueryGoodTransfersViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryGoodsIssueFindUniqueArgs = {
  uniqueInput?: InputMaybe<GoodsIssueUniqueInput>;
};


export type QueryGoodsIssuesViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryGoodsReceiveFindUniqueArgs = {
  uniqueInput?: InputMaybe<GoodsReceiveUniqueInput>;
};


export type QueryGoodsReceivesViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryItemFindUniqueArgs = {
  uniqueInput: ItemUniqueInput;
};


export type QueryItemIdByBarcodeArgs = {
  barcode: Scalars['String']['input'];
};


export type QueryItemSkuQtyByBarcodesViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryItemSkuQtyByBinLocationsViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryItemSkuQtyByWarehousesViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryItemSkuQtyItemSumArgs = {
  item_unique_id: Scalars['String']['input'];
};


export type QueryItemSkuQtysArgs = {
  findManyInput?: InputMaybe<ItemSkuQtyFindManyInput>;
};


export type QueryItemsFindManyAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryItemsViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryNoTraceEntryReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryTraceEntriesAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryTraceEntriesViewAggridArgs = {
  aggridInput: Scalars['AnyAggridInput']['input'];
};


export type QueryTraceEntryReportViewArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: InventoryModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: InventoryModelType;
  uniqueId: Scalars['String']['input'];
};


export type QueryValidateItemImportArgs = {
  validateInput: ItemInputValidateInput;
};

export type ReferenceDocumentList = {
  __typename?: 'ReferenceDocumentList';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceDocumentListInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type RelatedUser = {
  __typename?: 'RelatedUser';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type RelatedUserList = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportGenerateInput = {
  params?: InputMaybe<Scalars['Json']['input']>;
  priority: Scalars['Int']['input'];
  report_type: InventoryReportType;
  user_unique_id: Scalars['String']['input'];
};

export type ReportResult = {
  __typename?: 'ReportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesCustomerInputObject = {
  billing_address?: InputMaybe<AddressInputObject>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  identity_no?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCustomerObject = {
  __typename?: 'SalesCustomerObject';
  billing_address?: Maybe<AddressObject>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  identity_no?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SelectOptionById = {
  __typename?: 'SelectOptionById';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task'
}

export type TraceEntry = {
  __typename?: 'TraceEntry';
  barcode?: Maybe<Scalars['String']['output']>;
  created_date: Scalars['DateTime']['output'];
  destination_bin_location?: Maybe<BinLocation>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_scanned_by: Scalars['Json']['output'];
  destination_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  document_item_qty?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  is_lot?: Maybe<Scalars['Boolean']['output']>;
  item_img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  po_reference_unique_id?: Maybe<Scalars['String']['output']>;
  posted_qty?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_status?: Maybe<Scalars['String']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by: Scalars['Json']['output'];
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location?: Maybe<BinLocation>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<TraceEntryStatus>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  traceability: Traceability;
  type?: Maybe<TraceEntryType>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  uom_id?: Maybe<Scalars['Int']['output']>;
};

export type TraceEntryAggridOutput = {
  __typename?: 'TraceEntryAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<TraceEntry>;
};

export type TraceEntryCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  destination_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_scanned_by: Scalars['Json']['input'];
  destination_scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  document_item_qty?: InputMaybe<Scalars['Float']['input']>;
  is_lot?: InputMaybe<Scalars['Boolean']['input']>;
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  po_reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  posted_qty?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_status?: InputMaybe<Scalars['String']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  scanned_by: Scalars['Json']['input'];
  scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  source_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TraceEntryStatus>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  type: TraceEntryType;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['String']['input']>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TraceEntryReportView = {
  __typename?: 'TraceEntryReportView';
  created_by_name?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_bin_location_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TraceEntryType>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type TraceEntryReportViewAggrid = {
  __typename?: 'TraceEntryReportViewAggrid';
  count?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<TraceEntryReportView>>;
};

export enum TraceEntryStatus {
  IsActive = 'is_active',
  IsCancelled = 'is_cancelled',
  IsScanned = 'is_scanned'
}

export enum TraceEntryType {
  GoodAdjust = 'good_adjust',
  GoodIssue = 'good_issue',
  GoodReceive = 'good_receive',
  GoodTransfer = 'good_transfer'
}

export type TraceEntryUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  destination_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_scanned_by: Scalars['Json']['input'];
  destination_scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  document_item_qty?: InputMaybe<Scalars['Float']['input']>;
  is_lot?: InputMaybe<Scalars['Boolean']['input']>;
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  po_reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  posted_qty?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_status?: InputMaybe<Scalars['String']['input']>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  scanned_by: Scalars['Json']['input'];
  scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  seller_sku?: InputMaybe<Scalars['String']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  source_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TraceEntryStatus>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  type: TraceEntryType;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['String']['input']>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TraceEntryView = {
  __typename?: 'TraceEntryView';
  barcode?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_bin_location_name?: Maybe<Scalars['String']['output']>;
  destination_scanned_by?: Maybe<Scalars['Json']['output']>;
  destination_scanned_by_img_url?: Maybe<Array<Scalars['String']['output']>>;
  destination_scanned_by_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  finished_qty?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_name?: Maybe<Scalars['String']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  scanned_by?: Maybe<Scalars['Json']['output']>;
  scanned_by_img_url?: Maybe<Array<Scalars['String']['output']>>;
  scanned_by_name?: Maybe<Scalars['String']['output']>;
  scanned_date?: Maybe<Scalars['DateTime']['output']>;
  seller_sku?: Maybe<Scalars['String']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  source_bin_location_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_id?: Maybe<Scalars['Int']['output']>;
  source_warehouse_name?: Maybe<Scalars['String']['output']>;
  source_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TraceEntryType>;
  uom?: Maybe<Scalars['String']['output']>;
};

export type TraceEntryViewAggridOutput = {
  __typename?: 'TraceEntryViewAggridOutput';
  count: Scalars['Int']['output'];
  results: Array<TraceEntryView>;
};

export enum Traceability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export enum TraceabilityType {
  Traceability = 'traceability'
}

export type UomConversion = {
  __typename?: 'UomConversion';
  base_uom_id?: Maybe<Scalars['Int']['output']>;
  base_uom_name?: Maybe<Scalars['String']['output']>;
  base_uom_rate?: Maybe<Scalars['Float']['output']>;
  target_uom_id?: Maybe<Scalars['Int']['output']>;
  target_uom_name?: Maybe<Scalars['String']['output']>;
  target_uom_rate?: Maybe<Scalars['Float']['output']>;
};

export type UomConversionInput = {
  base_uom_id?: InputMaybe<Scalars['Int']['input']>;
  base_uom_name?: InputMaybe<Scalars['String']['input']>;
  base_uom_rate?: InputMaybe<Scalars['Float']['input']>;
  target_uom_id?: InputMaybe<Scalars['Int']['input']>;
  target_uom_name?: InputMaybe<Scalars['String']['input']>;
  target_uom_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGoodAdjustInput = {
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  flag_status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<GoodAdjustStatus>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  source_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  trace_entry_list?: InputMaybe<Array<InputMaybe<TraceEntryUpdateInput>>>;
};

export type ValidateItemImportResult = {
  __typename?: 'ValidateItemImportResult';
  existing_barcode_list?: Maybe<Array<Scalars['String']['output']>>;
  existing_item_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_cate_1_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_cate_2_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_cate_3_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_height_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_item_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_length_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_purchase_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_sales_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_stock_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_thickness_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_width_uom_id_list?: Maybe<Array<Scalars['String']['output']>>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  warehouse_level_1_list?: Maybe<Array<WarehouseLevel1>>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type GoodAdjustCreateMutationVariables = Exact<{
  createGoodAdjustInput: CreateGoodAdjustInput;
}>;


export type GoodAdjustCreateMutation = { __typename?: 'Mutation', GoodAdjustCreate: { __typename?: 'GoodAdjust', id?: number | null, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, main_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, name: string, unique_id: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } };

export type GoodAdjustFindUniqueQueryVariables = Exact<{
  uniqueInput: GoodsAdjustUniqueInput;
}>;


export type GoodAdjustFindUniqueQuery = { __typename?: 'Query', GoodAdjustFindUnique?: { __typename?: 'GoodAdjust', id?: number | null, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, main_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, name: string, unique_id: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } | null };

export type GoodAdjustUpdateMutationVariables = Exact<{
  uniqueInput: GoodsAdjustUniqueInput;
  updateGoodAdjustInput: UpdateGoodAdjustInput;
}>;


export type GoodAdjustUpdateMutation = { __typename?: 'Mutation', GoodAdjustUpdate: { __typename?: 'GoodAdjust', id?: number | null, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, main_status?: string | null, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, name: string, unique_id: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } };

export type GoodsIssueCreateMutationVariables = Exact<{
  createInput: GoodsIssueCreateInput;
}>;


export type GoodsIssueCreateMutation = { __typename?: 'Mutation', GoodsIssueCreate: { __typename?: 'GoodsIssue', id: number, unique_id: string, reference_unique_id?: string | null, posted_date?: any | null, created_date: any, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsIssueType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', unique_id: string, id: number, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } };

export type GoodsIssueFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsIssueUniqueInput>;
}>;


export type GoodsIssueFindUniqueQuery = { __typename?: 'Query', GoodsIssueFindUnique?: { __typename?: 'GoodsIssue', id: number, unique_id: string, reference_unique_id?: string | null, posted_date?: any | null, created_date: any, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsIssueType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', unique_id: string, id: number, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } | null };

export type GoodsIssueUpdateMutationVariables = Exact<{
  updateInput: GoodsIssueUpdateInput;
  uniqueInput: GoodsIssueUniqueInput;
}>;


export type GoodsIssueUpdateMutation = { __typename?: 'Mutation', GoodsIssueUpdate: { __typename?: 'GoodsIssue', id: number, unique_id: string, reference_unique_id?: string | null, posted_date?: any | null, created_date: any, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsIssueType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', unique_id: string, id: number, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } };

export type GoodsReceiveCreateMutationVariables = Exact<{
  createInput: GoodsReceiveCreateInput;
}>;


export type GoodsReceiveCreateMutation = { __typename?: 'Mutation', GoodsReceiveCreate: { __typename?: 'GoodsReceive', id: number, unique_id: string, posted_date?: any | null, reference_unique_id_list?: Array<string> | null, created_date: any, img_url?: Array<string> | null, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsReceiveType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } };

export type GoodsReceiveFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsReceiveUniqueInput>;
}>;


export type GoodsReceiveFindUniqueQuery = { __typename?: 'Query', GoodsReceiveFindUnique?: { __typename?: 'GoodsReceive', id: number, unique_id: string, posted_date?: any | null, reference_unique_id_list?: Array<string> | null, created_date: any, img_url?: Array<string> | null, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsReceiveType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } | null };

export type GoodsReceiveUpdateMutationVariables = Exact<{
  updateInput: GoodsReceiveUpdateInput;
  uniqueInput: GoodsReceiveUniqueInput;
}>;


export type GoodsReceiveUpdateMutation = { __typename?: 'Mutation', GoodsReceiveUpdate: { __typename?: 'GoodsReceive', id: number, unique_id: string, posted_date?: any | null, reference_unique_id_list?: Array<string> | null, created_date: any, img_url?: Array<string> | null, last_updated_date?: any | null, source_warehouse_id?: number | null, type?: GoodsReceiveType | null, main_status: string, flag_status?: Array<string> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, source_warehouse?: { __typename?: 'Warehouse', id: number, unique_id: string, name: string } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null }> | null } };

export type GoodTransferCreateMutationVariables = Exact<{
  data?: InputMaybe<GoodTransferCreateInput>;
}>;


export type GoodTransferCreateMutation = { __typename?: 'Mutation', GoodTransferCreate?: { __typename?: 'GoodTransfer', id: number, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, source_warehouse?: any | null, destination_warehouse_id?: number | null, destination_warehouse?: any | null, main_status: string, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } | null };

export type GoodTransferFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<GoodsTransferUniqueInput>;
}>;


export type GoodTransferFindUniqueQuery = { __typename?: 'Query', GoodTransferFindUnique?: { __typename?: 'GoodTransfer', id: number, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, source_warehouse?: any | null, destination_warehouse_id?: number | null, destination_warehouse?: any | null, main_status: string, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } | null };

export type GoodTransferUpdateMutationVariables = Exact<{
  uniqueInput: GoodsTransferUniqueInput;
  data?: InputMaybe<GoodTransferUpdateInput>;
}>;


export type GoodTransferUpdateMutation = { __typename?: 'Mutation', GoodTransferUpdate?: { __typename?: 'GoodTransfer', id: number, unique_id?: string | null, posted_date?: any | null, created_date?: any | null, last_updated_date?: any | null, source_warehouse_id?: number | null, source_warehouse?: any | null, destination_warehouse_id?: number | null, destination_warehouse?: any | null, main_status: string, flag_status?: Array<string | null> | null, aggrid_status?: string | null, remark?: string | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, trace_entry_list?: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any, source_bin_location?: { __typename?: 'BinLocation', name: string } | null, destination_bin_location?: { __typename?: 'BinLocation', name: string } | null } | null> | null } | null };

export type ImportNormalItemsMutationVariables = Exact<{
  importInput: ItemNormalImportInput;
}>;


export type ImportNormalItemsMutation = { __typename?: 'Mutation', ImportNormalItems: { __typename?: 'ItemImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, detail?: any | null } };

export type ImportServiceItemsMutationVariables = Exact<{
  importInput: ItemServiceImportInput;
}>;


export type ImportServiceItemsMutation = { __typename?: 'Mutation', ImportServiceItems: { __typename?: 'ItemImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, detail?: any | null } };

export type ValidateItemImportQueryVariables = Exact<{
  validateInput: ItemInputValidateInput;
}>;


export type ValidateItemImportQuery = { __typename?: 'Query', ValidateItemImport: { __typename?: 'ValidateItemImportResult', existing_item_unique_id_list?: Array<string> | null, missing_item_unique_id_list?: Array<string> | null, existing_barcode_list?: Array<string> | null, missing_uom_id_list?: Array<string> | null, missing_cate_1_id_list?: Array<string> | null, missing_cate_2_id_list?: Array<string> | null, missing_cate_3_id_list?: Array<string> | null, missing_width_uom_id_list?: Array<string> | null, missing_length_uom_id_list?: Array<string> | null, missing_height_uom_id_list?: Array<string> | null, missing_thickness_uom_id_list?: Array<string> | null, missing_stock_uom_id_list?: Array<string> | null, missing_sales_uom_id_list?: Array<string> | null, missing_purchase_uom_id_list?: Array<string> | null } };

export type InventoryDocumentCancelMutationVariables = Exact<{
  uniqueInput: InventoryControlUniqueInput;
  documentType?: InputMaybe<InventoryControlDocumentType>;
}>;


export type InventoryDocumentCancelMutation = { __typename?: 'Mutation', InventoryDocumentCancel?: { __typename?: 'InventoryDocumentCancelOutput', unique_id: string, aggrid_status?: string | null, flag_status?: Array<string> | null } | null };

export type GenerateReportNoQueueQueryVariables = Exact<{
  input: ReportGenerateInput;
}>;


export type GenerateReportNoQueueQuery = { __typename?: 'Query', GenerateReportNoQueue?: string | null };

export type ItemCreateMutationVariables = Exact<{
  createInput: ItemCreateInput;
}>;


export type ItemCreateMutation = { __typename?: 'Mutation', ItemCreate?: { __typename?: 'Item', id: number, unique_id: string, seller_sku?: string | null, type?: ItemType | null, name?: string | null, description?: string | null, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, remark_status?: string | null, tag_id_list?: Array<number> | null, last_updated_date?: any | null, created_date: any, created_by?: any | null, cate_1_id?: number | null, cate_2_id?: number | null, cate_3_id?: number | null, width_uom_id?: number | null, length_uom_id?: number | null, thickness_uom_id?: number | null, height_uom_id?: number | null, width?: number | null, length?: number | null, thick?: number | null, height?: number | null, tracability?: Traceability | null, barcode: string, stock_uom_id?: number | null, sales_uom_id?: number | null, purchase_uom_id?: number | null, purchase_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, min_stock_qty?: number | null, max_stock_qty?: number | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, img_url_list?: Array<{ __typename?: 'ImageUrlObject', img_url?: string | null, is_main_img?: boolean | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, cate_1?: { __typename?: 'InventorySetting', name: string } | null, cate_2?: { __typename?: 'InventorySetting', name: string } | null, cate_3?: { __typename?: 'InventorySetting', name: string } | null, width_uom?: { __typename?: 'InventorySetting', name: string } | null, length_uom?: { __typename?: 'InventorySetting', name: string } | null, thickness_uom?: { __typename?: 'InventorySetting', name: string } | null, height_uom?: { __typename?: 'InventorySetting', name: string } | null, stock_uom?: { __typename?: 'InventorySetting', name: string } | null, sales_uom?: { __typename?: 'InventorySetting', name: string } | null, purchase_uom?: { __typename?: 'InventorySetting', name: string } | null, uom_conversion_list?: Array<{ __typename?: 'UomConversion', base_uom_id?: number | null, base_uom_name?: string | null, base_uom_rate?: number | null, target_uom_id?: number | null, target_uom_name?: string | null, target_uom_rate?: number | null }> | null } | null };

export type ItemDeleteMutationVariables = Exact<{
  uniqueInput: ItemUniqueInput;
}>;


export type ItemDeleteMutation = { __typename?: 'Mutation', ItemDelete?: { __typename?: 'Item', id: number, name?: string | null, unique_id: string } | null };

export type ItemIdByBarcodeQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
}>;


export type ItemIdByBarcodeQuery = { __typename?: 'Query', ItemIdByBarcode?: { __typename?: 'ItemIdByBarcodeOutput', id?: number | null, type?: ItemType | null } | null };

export type ItemFindUniqueQueryVariables = Exact<{
  uniqueInput: ItemUniqueInput;
}>;


export type ItemFindUniqueQuery = { __typename?: 'Query', ItemFindUnique?: { __typename?: 'Item', id: number, unique_id: string, seller_sku?: string | null, type?: ItemType | null, name?: string | null, description?: string | null, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, remark_status?: string | null, tag_id_list?: Array<number> | null, last_updated_date?: any | null, created_date: any, created_by?: any | null, cate_1_id?: number | null, cate_2_id?: number | null, cate_3_id?: number | null, width_uom_id?: number | null, length_uom_id?: number | null, thickness_uom_id?: number | null, height_uom_id?: number | null, width?: number | null, length?: number | null, thick?: number | null, height?: number | null, tracability?: Traceability | null, barcode: string, stock_uom_id?: number | null, sales_uom_id?: number | null, purchase_uom_id?: number | null, purchase_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, min_stock_qty?: number | null, max_stock_qty?: number | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, img_url_list?: Array<{ __typename?: 'ImageUrlObject', img_url?: string | null, is_main_img?: boolean | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, cate_1?: { __typename?: 'InventorySetting', name: string } | null, cate_2?: { __typename?: 'InventorySetting', name: string } | null, cate_3?: { __typename?: 'InventorySetting', name: string } | null, width_uom?: { __typename?: 'InventorySetting', name: string } | null, length_uom?: { __typename?: 'InventorySetting', name: string } | null, thickness_uom?: { __typename?: 'InventorySetting', name: string } | null, height_uom?: { __typename?: 'InventorySetting', name: string } | null, stock_uom?: { __typename?: 'InventorySetting', name: string } | null, sales_uom?: { __typename?: 'InventorySetting', name: string } | null, purchase_uom?: { __typename?: 'InventorySetting', name: string } | null, uom_conversion_list?: Array<{ __typename?: 'UomConversion', base_uom_id?: number | null, base_uom_name?: string | null, base_uom_rate?: number | null, target_uom_id?: number | null, target_uom_name?: string | null, target_uom_rate?: number | null }> | null } | null };

export type ItemSkuQtyItemSumQueryVariables = Exact<{
  itemUniqueId: Scalars['String']['input'];
}>;


export type ItemSkuQtyItemSumQuery = { __typename?: 'Query', ItemSkuQtyItemSum: { __typename?: 'ItemSkuQtyItemSumOutput', item_unique_id: string, stock_qty: number, available_qty: number, purchase_ordered_qty: number, sale_committed_qty: number } };

export type ItemUpdateMutationVariables = Exact<{
  uniqueInput: ItemUniqueInput;
  updateInput: ItemUpdateInput;
}>;


export type ItemUpdateMutation = { __typename?: 'Mutation', ItemUpdate?: { __typename?: 'Item', id: number, unique_id: string, seller_sku?: string | null, type?: ItemType | null, name?: string | null, description?: string | null, is_purchasable?: boolean | null, is_saleable?: boolean | null, is_stockable?: boolean | null, is_active: number, remark_status?: string | null, tag_id_list?: Array<number> | null, last_updated_date?: any | null, created_date: any, created_by?: any | null, cate_1_id?: number | null, cate_2_id?: number | null, cate_3_id?: number | null, width_uom_id?: number | null, length_uom_id?: number | null, thickness_uom_id?: number | null, height_uom_id?: number | null, width?: number | null, length?: number | null, thick?: number | null, height?: number | null, tracability?: Traceability | null, barcode: string, stock_uom_id?: number | null, sales_uom_id?: number | null, purchase_uom_id?: number | null, purchase_price?: number | null, min_purchase_request_qty?: number | null, purchase_vat_type?: string | null, sale_price?: number | null, special_price?: number | null, sale_vat_type?: string | null, min_stock_qty?: number | null, max_stock_qty?: number | null, stock_qty?: number | null, available_qty?: number | null, purchase_ordered_qty?: number | null, sale_committed_qty?: number | null, img_url_list?: Array<{ __typename?: 'ImageUrlObject', img_url?: string | null, is_main_img?: boolean | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string }> | null, cate_1?: { __typename?: 'InventorySetting', name: string } | null, cate_2?: { __typename?: 'InventorySetting', name: string } | null, cate_3?: { __typename?: 'InventorySetting', name: string } | null, width_uom?: { __typename?: 'InventorySetting', name: string } | null, length_uom?: { __typename?: 'InventorySetting', name: string } | null, thickness_uom?: { __typename?: 'InventorySetting', name: string } | null, height_uom?: { __typename?: 'InventorySetting', name: string } | null, stock_uom?: { __typename?: 'InventorySetting', name: string } | null, sales_uom?: { __typename?: 'InventorySetting', name: string } | null, purchase_uom?: { __typename?: 'InventorySetting', name: string } | null, uom_conversion_list?: Array<{ __typename?: 'UomConversion', base_uom_id?: number | null, base_uom_name?: string | null, base_uom_rate?: number | null, target_uom_id?: number | null, target_uom_name?: string | null, target_uom_rate?: number | null }> | null } | null };

export type ItemsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemsCountQuery = { __typename?: 'Query', ItemsCount: { __typename?: 'ItemCountOutput', total: number, normal: number, service: number } };

export type ItemSkuQtysQueryVariables = Exact<{
  findManyInput?: InputMaybe<ItemSkuQtyFindManyInput>;
}>;


export type ItemSkuQtysQuery = { __typename?: 'Query', ItemSkuQtys?: Array<{ __typename?: 'ItemSkuQty', id: number, item_unique_id: string, bin_location_id: number, bin_name: string, warehouse_id: number, warehouse_name: string, barcode: string, serial_no: string, lot_date?: any | null, manufactured_date?: any | null, expired_date?: any | null, stock_qty: number, available_qty: number, purchase_ordered_qty: number, sale_committed_qty: number } | null> | null };

export type TraceEntriesAggridQueryVariables = Exact<{
  aggridInput: Scalars['AnyAggridInput']['input'];
}>;


export type TraceEntriesAggridQuery = { __typename?: 'Query', TraceEntriesAggrid: { __typename?: 'TraceEntryAggridOutput', count: number, results: Array<{ __typename?: 'TraceEntry', id: number, unique_id: string, created_date: any, type?: TraceEntryType | null, reference_status?: string | null, reference_unique_id?: string | null, reference_line_item?: any | null, item_unique_id: string, item_name: string, seller_sku?: string | null, item_img_url?: Array<string | null> | null, po_reference_unique_id?: string | null, document_item_qty?: number | null, posted_qty?: number | null, qty: number, stock_qty?: number | null, uom_id?: number | null, uom?: string | null, remark?: string | null, is_lot?: boolean | null, lot_date?: any | null, source_bin_location_id?: number | null, destination_bin_location_id?: number | null, traceability: Traceability, barcode?: string | null, serial_no?: string | null, status?: TraceEntryStatus | null, scanned_date?: any | null, scanned_by: any, destination_scanned_date?: any | null, destination_scanned_by: any }> } };

export type WmsUniqueIdGenerateQueryVariables = Exact<{
  modelType: InventoryModelType;
}>;


export type WmsUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };


export const GoodAdjustCreateDocument = `
    mutation GoodAdjustCreate($createGoodAdjustInput: CreateGoodAdjustInput!) {
  GoodAdjustCreate(createGoodAdjustInput: $createGoodAdjustInput) {
    id
    unique_id
    posted_date
    created_date
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      name
      unique_id
    }
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodAdjustCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodAdjustCreateMutation, TError, GoodAdjustCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodAdjustCreateMutation, TError, GoodAdjustCreateMutationVariables, TContext>(
      ['GoodAdjustCreate'],
      (variables?: GoodAdjustCreateMutationVariables) => fetcher<GoodAdjustCreateMutation, GoodAdjustCreateMutationVariables>(client, GoodAdjustCreateDocument, variables, headers)(),
      options
    );
export const GoodAdjustFindUniqueDocument = `
    query GoodAdjustFindUnique($uniqueInput: GoodsAdjustUniqueInput!) {
  GoodAdjustFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    posted_date
    created_date
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      name
      unique_id
    }
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodAdjustFindUniqueQuery = <
      TData = GoodAdjustFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GoodAdjustFindUniqueQueryVariables,
      options?: UseQueryOptions<GoodAdjustFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodAdjustFindUniqueQuery, TError, TData>(
      ['GoodAdjustFindUnique', variables],
      fetcher<GoodAdjustFindUniqueQuery, GoodAdjustFindUniqueQueryVariables>(client, GoodAdjustFindUniqueDocument, variables, headers),
      options
    );
export const GoodAdjustUpdateDocument = `
    mutation GoodAdjustUpdate($uniqueInput: GoodsAdjustUniqueInput!, $updateGoodAdjustInput: UpdateGoodAdjustInput!) {
  GoodAdjustUpdate(
    uniqueInput: $uniqueInput
    updateGoodAdjustInput: $updateGoodAdjustInput
  ) {
    id
    unique_id
    posted_date
    created_date
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      name
      unique_id
    }
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodAdjustUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodAdjustUpdateMutation, TError, GoodAdjustUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodAdjustUpdateMutation, TError, GoodAdjustUpdateMutationVariables, TContext>(
      ['GoodAdjustUpdate'],
      (variables?: GoodAdjustUpdateMutationVariables) => fetcher<GoodAdjustUpdateMutation, GoodAdjustUpdateMutationVariables>(client, GoodAdjustUpdateDocument, variables, headers)(),
      options
    );
export const GoodsIssueCreateDocument = `
    mutation GoodsIssueCreate($createInput: GoodsIssueCreateInput!) {
  GoodsIssueCreate(createInput: $createInput) {
    id
    unique_id
    reference_unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      unique_id
      id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsIssueCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsIssueCreateMutation, TError, GoodsIssueCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsIssueCreateMutation, TError, GoodsIssueCreateMutationVariables, TContext>(
      ['GoodsIssueCreate'],
      (variables?: GoodsIssueCreateMutationVariables) => fetcher<GoodsIssueCreateMutation, GoodsIssueCreateMutationVariables>(client, GoodsIssueCreateDocument, variables, headers)(),
      options
    );
export const GoodsIssueFindUniqueDocument = `
    query GoodsIssueFindUnique($uniqueInput: GoodsIssueUniqueInput) {
  GoodsIssueFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      unique_id
      id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsIssueFindUniqueQuery = <
      TData = GoodsIssueFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsIssueFindUniqueQueryVariables,
      options?: UseQueryOptions<GoodsIssueFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsIssueFindUniqueQuery, TError, TData>(
      variables === undefined ? ['GoodsIssueFindUnique'] : ['GoodsIssueFindUnique', variables],
      fetcher<GoodsIssueFindUniqueQuery, GoodsIssueFindUniqueQueryVariables>(client, GoodsIssueFindUniqueDocument, variables, headers),
      options
    );
export const GoodsIssueUpdateDocument = `
    mutation GoodsIssueUpdate($updateInput: GoodsIssueUpdateInput!, $uniqueInput: GoodsIssueUniqueInput!) {
  GoodsIssueUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    reference_unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      unique_id
      id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsIssueUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsIssueUpdateMutation, TError, GoodsIssueUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsIssueUpdateMutation, TError, GoodsIssueUpdateMutationVariables, TContext>(
      ['GoodsIssueUpdate'],
      (variables?: GoodsIssueUpdateMutationVariables) => fetcher<GoodsIssueUpdateMutation, GoodsIssueUpdateMutationVariables>(client, GoodsIssueUpdateDocument, variables, headers)(),
      options
    );
export const GoodsReceiveCreateDocument = `
    mutation GoodsReceiveCreate($createInput: GoodsReceiveCreateInput!) {
  GoodsReceiveCreate(createInput: $createInput) {
    id
    unique_id
    posted_date
    reference_unique_id_list
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    img_url
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsReceiveCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReceiveCreateMutation, TError, GoodsReceiveCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReceiveCreateMutation, TError, GoodsReceiveCreateMutationVariables, TContext>(
      ['GoodsReceiveCreate'],
      (variables?: GoodsReceiveCreateMutationVariables) => fetcher<GoodsReceiveCreateMutation, GoodsReceiveCreateMutationVariables>(client, GoodsReceiveCreateDocument, variables, headers)(),
      options
    );
export const GoodsReceiveFindUniqueDocument = `
    query GoodsReceiveFindUnique($uniqueInput: GoodsReceiveUniqueInput) {
  GoodsReceiveFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    posted_date
    reference_unique_id_list
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    img_url
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsReceiveFindUniqueQuery = <
      TData = GoodsReceiveFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodsReceiveFindUniqueQueryVariables,
      options?: UseQueryOptions<GoodsReceiveFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodsReceiveFindUniqueQuery, TError, TData>(
      variables === undefined ? ['GoodsReceiveFindUnique'] : ['GoodsReceiveFindUnique', variables],
      fetcher<GoodsReceiveFindUniqueQuery, GoodsReceiveFindUniqueQueryVariables>(client, GoodsReceiveFindUniqueDocument, variables, headers),
      options
    );
export const GoodsReceiveUpdateDocument = `
    mutation GoodsReceiveUpdate($updateInput: GoodsReceiveUpdateInput!, $uniqueInput: GoodsReceiveUniqueInput!) {
  GoodsReceiveUpdate(updateInput: $updateInput, uniqueInput: $uniqueInput) {
    id
    unique_id
    posted_date
    reference_unique_id_list
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    img_url
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse {
      id
      unique_id
      name
    }
    type
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodsReceiveUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodsReceiveUpdateMutation, TError, GoodsReceiveUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodsReceiveUpdateMutation, TError, GoodsReceiveUpdateMutationVariables, TContext>(
      ['GoodsReceiveUpdate'],
      (variables?: GoodsReceiveUpdateMutationVariables) => fetcher<GoodsReceiveUpdateMutation, GoodsReceiveUpdateMutationVariables>(client, GoodsReceiveUpdateDocument, variables, headers)(),
      options
    );
export const GoodTransferCreateDocument = `
    mutation GoodTransferCreate($data: GoodTransferCreateInput) {
  GoodTransferCreate(data: $data) {
    id
    unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse
    destination_warehouse_id
    destination_warehouse
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodTransferCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodTransferCreateMutation, TError, GoodTransferCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodTransferCreateMutation, TError, GoodTransferCreateMutationVariables, TContext>(
      ['GoodTransferCreate'],
      (variables?: GoodTransferCreateMutationVariables) => fetcher<GoodTransferCreateMutation, GoodTransferCreateMutationVariables>(client, GoodTransferCreateDocument, variables, headers)(),
      options
    );
export const GoodTransferFindUniqueDocument = `
    query GoodTransferFindUnique($uniqueInput: GoodsTransferUniqueInput) {
  GoodTransferFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse
    destination_warehouse_id
    destination_warehouse
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodTransferFindUniqueQuery = <
      TData = GoodTransferFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GoodTransferFindUniqueQueryVariables,
      options?: UseQueryOptions<GoodTransferFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GoodTransferFindUniqueQuery, TError, TData>(
      variables === undefined ? ['GoodTransferFindUnique'] : ['GoodTransferFindUnique', variables],
      fetcher<GoodTransferFindUniqueQuery, GoodTransferFindUniqueQueryVariables>(client, GoodTransferFindUniqueDocument, variables, headers),
      options
    );
export const GoodTransferUpdateDocument = `
    mutation GoodTransferUpdate($uniqueInput: GoodsTransferUniqueInput!, $data: GoodTransferUpdateInput) {
  GoodTransferUpdate(uniqueInput: $uniqueInput, data: $data) {
    id
    unique_id
    posted_date
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    source_warehouse_id
    source_warehouse
    destination_warehouse_id
    destination_warehouse
    main_status
    flag_status
    aggrid_status
    remark
    trace_entry_list {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      source_bin_location {
        name
      }
      destination_bin_location_id
      destination_bin_location {
        name
      }
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useGoodTransferUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GoodTransferUpdateMutation, TError, GoodTransferUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GoodTransferUpdateMutation, TError, GoodTransferUpdateMutationVariables, TContext>(
      ['GoodTransferUpdate'],
      (variables?: GoodTransferUpdateMutationVariables) => fetcher<GoodTransferUpdateMutation, GoodTransferUpdateMutationVariables>(client, GoodTransferUpdateDocument, variables, headers)(),
      options
    );
export const ImportNormalItemsDocument = `
    mutation ImportNormalItems($importInput: ItemNormalImportInput!) {
  ImportNormalItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    detail
  }
}
    `;
export const useImportNormalItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportNormalItemsMutation, TError, ImportNormalItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportNormalItemsMutation, TError, ImportNormalItemsMutationVariables, TContext>(
      ['ImportNormalItems'],
      (variables?: ImportNormalItemsMutationVariables) => fetcher<ImportNormalItemsMutation, ImportNormalItemsMutationVariables>(client, ImportNormalItemsDocument, variables, headers)(),
      options
    );
export const ImportServiceItemsDocument = `
    mutation ImportServiceItems($importInput: ItemServiceImportInput!) {
  ImportServiceItems(importInput: $importInput) {
    success
    timestamp
    status
    message
    detail
  }
}
    `;
export const useImportServiceItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportServiceItemsMutation, TError, ImportServiceItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportServiceItemsMutation, TError, ImportServiceItemsMutationVariables, TContext>(
      ['ImportServiceItems'],
      (variables?: ImportServiceItemsMutationVariables) => fetcher<ImportServiceItemsMutation, ImportServiceItemsMutationVariables>(client, ImportServiceItemsDocument, variables, headers)(),
      options
    );
export const ValidateItemImportDocument = `
    query ValidateItemImport($validateInput: ItemInputValidateInput!) {
  ValidateItemImport(validateInput: $validateInput) {
    existing_item_unique_id_list
    missing_item_unique_id_list
    existing_barcode_list
    missing_uom_id_list
    missing_cate_1_id_list
    missing_cate_2_id_list
    missing_cate_3_id_list
    missing_width_uom_id_list
    missing_length_uom_id_list
    missing_height_uom_id_list
    missing_thickness_uom_id_list
    missing_stock_uom_id_list
    missing_sales_uom_id_list
    missing_purchase_uom_id_list
  }
}
    `;
export const useValidateItemImportQuery = <
      TData = ValidateItemImportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateItemImportQueryVariables,
      options?: UseQueryOptions<ValidateItemImportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateItemImportQuery, TError, TData>(
      ['ValidateItemImport', variables],
      fetcher<ValidateItemImportQuery, ValidateItemImportQueryVariables>(client, ValidateItemImportDocument, variables, headers),
      options
    );
export const InventoryDocumentCancelDocument = `
    mutation InventoryDocumentCancel($uniqueInput: InventoryControlUniqueInput!, $documentType: InventoryControlDocumentType) {
  InventoryDocumentCancel(uniqueInput: $uniqueInput, documentType: $documentType) {
    unique_id
    aggrid_status
    flag_status
  }
}
    `;
export const useInventoryDocumentCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InventoryDocumentCancelMutation, TError, InventoryDocumentCancelMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InventoryDocumentCancelMutation, TError, InventoryDocumentCancelMutationVariables, TContext>(
      ['InventoryDocumentCancel'],
      (variables?: InventoryDocumentCancelMutationVariables) => fetcher<InventoryDocumentCancelMutation, InventoryDocumentCancelMutationVariables>(client, InventoryDocumentCancelDocument, variables, headers)(),
      options
    );
export const GenerateReportNoQueueDocument = `
    query GenerateReportNoQueue($input: ReportGenerateInput!) {
  GenerateReportNoQueue(input: $input)
}
    `;
export const useGenerateReportNoQueueQuery = <
      TData = GenerateReportNoQueueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GenerateReportNoQueueQueryVariables,
      options?: UseQueryOptions<GenerateReportNoQueueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateReportNoQueueQuery, TError, TData>(
      ['GenerateReportNoQueue', variables],
      fetcher<GenerateReportNoQueueQuery, GenerateReportNoQueueQueryVariables>(client, GenerateReportNoQueueDocument, variables, headers),
      options
    );
export const ItemCreateDocument = `
    mutation ItemCreate($createInput: ItemCreateInput!) {
  ItemCreate(createInput: $createInput) {
    id
    unique_id
    seller_sku
    type
    name
    description
    img_url_list {
      img_url
      is_main_img
    }
    is_purchasable
    is_saleable
    is_stockable
    is_active
    remark_status
    tag_id_list
    tag_list {
      id
      name
    }
    last_updated_date
    created_date
    created_by
    cate_1_id
    cate_1 {
      name
    }
    cate_2_id
    cate_2 {
      name
    }
    cate_3_id
    cate_3 {
      name
    }
    width_uom_id
    width_uom {
      name
    }
    length_uom_id
    length_uom {
      name
    }
    thickness_uom_id
    thickness_uom {
      name
    }
    height_uom_id
    height_uom {
      name
    }
    width
    length
    thick
    height
    tracability
    barcode
    stock_uom_id
    stock_uom {
      name
    }
    sales_uom_id
    sales_uom {
      name
    }
    purchase_uom_id
    purchase_uom {
      name
    }
    uom_conversion_list {
      base_uom_id
      base_uom_name
      base_uom_rate
      target_uom_id
      target_uom_name
      target_uom_rate
    }
    purchase_price
    min_purchase_request_qty
    purchase_vat_type
    sale_price
    special_price
    sale_vat_type
    min_stock_qty
    max_stock_qty
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
  }
}
    `;
export const useItemCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemCreateMutation, TError, ItemCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemCreateMutation, TError, ItemCreateMutationVariables, TContext>(
      ['ItemCreate'],
      (variables?: ItemCreateMutationVariables) => fetcher<ItemCreateMutation, ItemCreateMutationVariables>(client, ItemCreateDocument, variables, headers)(),
      options
    );
export const ItemDeleteDocument = `
    mutation ItemDelete($uniqueInput: ItemUniqueInput!) {
  ItemDelete(uniqueInput: $uniqueInput) {
    id
    name
    unique_id
  }
}
    `;
export const useItemDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemDeleteMutation, TError, ItemDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemDeleteMutation, TError, ItemDeleteMutationVariables, TContext>(
      ['ItemDelete'],
      (variables?: ItemDeleteMutationVariables) => fetcher<ItemDeleteMutation, ItemDeleteMutationVariables>(client, ItemDeleteDocument, variables, headers)(),
      options
    );
export const ItemIdByBarcodeDocument = `
    query ItemIdByBarcode($barcode: String!) {
  ItemIdByBarcode(barcode: $barcode) {
    id
    type
  }
}
    `;
export const useItemIdByBarcodeQuery = <
      TData = ItemIdByBarcodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemIdByBarcodeQueryVariables,
      options?: UseQueryOptions<ItemIdByBarcodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemIdByBarcodeQuery, TError, TData>(
      ['ItemIdByBarcode', variables],
      fetcher<ItemIdByBarcodeQuery, ItemIdByBarcodeQueryVariables>(client, ItemIdByBarcodeDocument, variables, headers),
      options
    );
export const ItemFindUniqueDocument = `
    query ItemFindUnique($uniqueInput: ItemUniqueInput!) {
  ItemFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    seller_sku
    type
    name
    description
    img_url_list {
      img_url
      is_main_img
    }
    is_purchasable
    is_saleable
    is_stockable
    is_active
    remark_status
    tag_id_list
    tag_list {
      id
      name
    }
    last_updated_date
    created_date
    created_by
    cate_1_id
    cate_1 {
      name
    }
    cate_2_id
    cate_2 {
      name
    }
    cate_3_id
    cate_3 {
      name
    }
    width_uom_id
    width_uom {
      name
    }
    length_uom_id
    length_uom {
      name
    }
    thickness_uom_id
    thickness_uom {
      name
    }
    height_uom_id
    height_uom {
      name
    }
    width
    length
    thick
    height
    tracability
    barcode
    stock_uom_id
    stock_uom {
      name
    }
    sales_uom_id
    sales_uom {
      name
    }
    purchase_uom_id
    purchase_uom {
      name
    }
    uom_conversion_list {
      base_uom_id
      base_uom_name
      base_uom_rate
      target_uom_id
      target_uom_name
      target_uom_rate
    }
    purchase_price
    min_purchase_request_qty
    purchase_vat_type
    sale_price
    special_price
    sale_vat_type
    min_stock_qty
    max_stock_qty
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
  }
}
    `;
export const useItemFindUniqueQuery = <
      TData = ItemFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemFindUniqueQueryVariables,
      options?: UseQueryOptions<ItemFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemFindUniqueQuery, TError, TData>(
      ['ItemFindUnique', variables],
      fetcher<ItemFindUniqueQuery, ItemFindUniqueQueryVariables>(client, ItemFindUniqueDocument, variables, headers),
      options
    );
export const ItemSkuQtyItemSumDocument = `
    query ItemSkuQtyItemSum($itemUniqueId: String!) {
  ItemSkuQtyItemSum(item_unique_id: $itemUniqueId) {
    item_unique_id
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
  }
}
    `;
export const useItemSkuQtyItemSumQuery = <
      TData = ItemSkuQtyItemSumQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ItemSkuQtyItemSumQueryVariables,
      options?: UseQueryOptions<ItemSkuQtyItemSumQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuQtyItemSumQuery, TError, TData>(
      ['ItemSkuQtyItemSum', variables],
      fetcher<ItemSkuQtyItemSumQuery, ItemSkuQtyItemSumQueryVariables>(client, ItemSkuQtyItemSumDocument, variables, headers),
      options
    );
export const ItemUpdateDocument = `
    mutation ItemUpdate($uniqueInput: ItemUniqueInput!, $updateInput: ItemUpdateInput!) {
  ItemUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    seller_sku
    type
    name
    description
    img_url_list {
      img_url
      is_main_img
    }
    is_purchasable
    is_saleable
    is_stockable
    is_active
    remark_status
    tag_id_list
    tag_list {
      id
      name
    }
    last_updated_date
    created_date
    created_by
    cate_1_id
    cate_1 {
      name
    }
    cate_2_id
    cate_2 {
      name
    }
    cate_3_id
    cate_3 {
      name
    }
    width_uom_id
    width_uom {
      name
    }
    length_uom_id
    length_uom {
      name
    }
    thickness_uom_id
    thickness_uom {
      name
    }
    height_uom_id
    height_uom {
      name
    }
    width
    length
    thick
    height
    tracability
    barcode
    stock_uom_id
    stock_uom {
      name
    }
    sales_uom_id
    sales_uom {
      name
    }
    purchase_uom_id
    purchase_uom {
      name
    }
    uom_conversion_list {
      base_uom_id
      base_uom_name
      base_uom_rate
      target_uom_id
      target_uom_name
      target_uom_rate
    }
    purchase_price
    min_purchase_request_qty
    purchase_vat_type
    sale_price
    special_price
    sale_vat_type
    min_stock_qty
    max_stock_qty
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
  }
}
    `;
export const useItemUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ItemUpdateMutation, TError, ItemUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ItemUpdateMutation, TError, ItemUpdateMutationVariables, TContext>(
      ['ItemUpdate'],
      (variables?: ItemUpdateMutationVariables) => fetcher<ItemUpdateMutation, ItemUpdateMutationVariables>(client, ItemUpdateDocument, variables, headers)(),
      options
    );
export const ItemsCountDocument = `
    query ItemsCount {
  ItemsCount {
    total
    normal
    service
  }
}
    `;
export const useItemsCountQuery = <
      TData = ItemsCountQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemsCountQueryVariables,
      options?: UseQueryOptions<ItemsCountQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemsCountQuery, TError, TData>(
      variables === undefined ? ['ItemsCount'] : ['ItemsCount', variables],
      fetcher<ItemsCountQuery, ItemsCountQueryVariables>(client, ItemsCountDocument, variables, headers),
      options
    );
export const ItemSkuQtysDocument = `
    query ItemSkuQtys($findManyInput: ItemSkuQtyFindManyInput) {
  ItemSkuQtys(findManyInput: $findManyInput) {
    id
    item_unique_id
    bin_location_id
    bin_name
    warehouse_id
    warehouse_name
    barcode
    serial_no
    lot_date
    manufactured_date
    expired_date
    stock_qty
    available_qty
    purchase_ordered_qty
    sale_committed_qty
  }
}
    `;
export const useItemSkuQtysQuery = <
      TData = ItemSkuQtysQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ItemSkuQtysQueryVariables,
      options?: UseQueryOptions<ItemSkuQtysQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ItemSkuQtysQuery, TError, TData>(
      variables === undefined ? ['ItemSkuQtys'] : ['ItemSkuQtys', variables],
      fetcher<ItemSkuQtysQuery, ItemSkuQtysQueryVariables>(client, ItemSkuQtysDocument, variables, headers),
      options
    );
export const TraceEntriesAggridDocument = `
    query TraceEntriesAggrid($aggridInput: AnyAggridInput!) {
  TraceEntriesAggrid(aggridInput: $aggridInput) {
    count
    results {
      id
      unique_id
      created_date
      type
      reference_status
      reference_unique_id
      reference_line_item
      item_unique_id
      item_name
      seller_sku
      item_img_url
      po_reference_unique_id
      document_item_qty
      posted_qty
      qty
      stock_qty
      uom_id
      uom
      remark
      is_lot
      lot_date
      source_bin_location_id
      destination_bin_location_id
      traceability
      barcode
      serial_no
      status
      scanned_date
      scanned_by
      destination_scanned_date
      destination_scanned_by
    }
  }
}
    `;
export const useTraceEntriesAggridQuery = <
      TData = TraceEntriesAggridQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TraceEntriesAggridQueryVariables,
      options?: UseQueryOptions<TraceEntriesAggridQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TraceEntriesAggridQuery, TError, TData>(
      ['TraceEntriesAggrid', variables],
      fetcher<TraceEntriesAggridQuery, TraceEntriesAggridQueryVariables>(client, TraceEntriesAggridDocument, variables, headers),
      options
    );
export const WmsUniqueIdGenerateDocument = `
    query WmsUniqueIdGenerate($modelType: InventoryModelType!) {
  UniqueIdGenerate(modelType: $modelType)
}
    `;
export const useWmsUniqueIdGenerateQuery = <
      TData = WmsUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: WmsUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<WmsUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<WmsUniqueIdGenerateQuery, TError, TData>(
      ['WmsUniqueIdGenerate', variables],
      fetcher<WmsUniqueIdGenerateQuery, WmsUniqueIdGenerateQueryVariables>(client, WmsUniqueIdGenerateDocument, variables, headers),
      options
    );